export type MetaFbq = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[];
  loaded?: boolean;
  version?: string;
  push?: (...args: unknown[]) => void;
};

export const META_PIXEL_SCRIPT_SRC =
  'https://connect.facebook.net/en_US/fbevents.js';
